/*
 * Stands in for `process.env` throughout the frontend (wired up by ProvidePlugin in webpack/core.js).
 *
 * The values used to be compiled in, which meant a template's configuration was part of its bundle's
 * bytes — and therefore that every one of ~50 templates needed its own full build. They now arrive
 * at runtime from the page (see resources/views/partials/frontend_env.blade.php), so the same bundle
 * serves the whole fleet.
 *
 * The page defines this before any bundle, so reading it at module scope is safe. Frozen because
 * the old compiled object was effectively immutable and some callers rely on that.
 */
export default Object.freeze((typeof window !== 'undefined' && window.__APP_ENV__) || {});
